import React from 'react';

export type ChildRowContextType = 'childRowContext' | null;
export const ChildRowContextValue: ChildRowContextType = 'childRowContext';

export const ChildRowContext = React.createContext<ChildRowContextType>(null);
